import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { PROVEED} from "./types";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";

type ProveedoresContext = ActionContext<PROVEED, RootState>;
type ProveedoresActionTree = ActionTree<PROVEED, RootState>;

export const actions: ProveedoresActionTree = {
  async listarProveedores(context: ProveedoresContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Proveedores/ListaProveedores",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  }
};
